import React from 'react';
import './Footer.css';
import { Link } from "react-router-dom"

const Footer = () => {
  return (
    <footer id="ruk-main-footer" className="ruk-footer">
      <div id="ruk-footer-container" className="ruk-footer-container">
        <div id="ruk-footer-sections" className="ruk-footer-sections">
          <div id="ruk-logo-section" className="ruk-footer-section ruk-logo-section">
            <div id="ruk-university-logo" className="ruk-university-logo">
              <div id="ruk-logo-text-container" className="ruk-logo-text-container">
                <h2 id="ruk-logo-text" className="ruk-logo-text">
                  <span className="ruk-uni-name-red">Rayalaseema</span>
                  <span className="ruk-uni-name-white">University</span>
                </h2>
              </div>
            </div>
            <div id="ruk-accreditation-text" className="ruk-accreditation-text">
              Recognized Under Sections 2(f) and 12B of UGC Act, 1956<br />
              Accredited by NAAC with 'B' Grade<br />
              Kurnool-518007, Andhra Pradesh, India
            </div>
          </div>

          <div id="ruk-theme-section" className="ruk-footer-section ruk-theme-section">
            <h3 id="ruk-theme-heading" className="ruk-footer-heading">University Theme</h3>
            <div className="ruk-divider"></div>
            <blockquote id="ruk-theme-text" className="ruk-theme-text">
              To achieve national distinction for creativity, innovation and excellence, and become -- through leadership in teaching, research, scholarship, and social action -- a great leader in higher education and contribute to the building of a more humane, just, and sustain-able world.
            </blockquote>
          </div>

          <div id="ruk-academic-section" className="ruk-footer-section ruk-academic-section">
            <h3 id="ruk-academic-heading" className="ruk-footer-heading">Academic Support</h3>
            <div className="ruk-divider"></div>
            <ul id="ruk-academic-links" className="ruk-footer-links">
              <li><a href="/library" className="ruk-footer-link">Library</a></li>

              <li>
                <Link to="/campuslife/sports" className="ruk-footer-link">
                  Sports
                </Link>
              </li>
              <li>
                <Link to="/campuslife/nss" className="ruk-footer-link">
                  National Service Scheme
                </Link>
              </li>
             
            </ul>
          </div>

          <div id="ruk-other-links-section" className="ruk-footer-section ruk-other-links-section">
            <h3 id="ruk-other-links-heading" className="ruk-footer-heading">Other Links</h3>
            <div className="ruk-divider"></div>
            <ul id="ruk-other-links" className="ruk-footer-links">
              <li><a href="/nirf" className="ruk-footer-link">NIRF</a></li>
              <li><a href="/cnc" className="ruk-footer-link">CNC</a></li>
              <li><a href="/ncte" className="ruk-footer-link">NCTE</a></li>
              <li><a href="/gallery" className="ruk-footer-link">Gallery</a></li>
            </ul>
          </div>
        </div>

        <div id="ruk-footer-bottom" className="ruk-footer-bottom">
          <p id="ruk-copyright-text">© {new Date().getFullYear()} Rayalaseema University. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;